import type { IComponentController, IOnChangesObject } from 'angular'

import { app } from '../../app.module'

/**
 * オートコンプリート検索フォーム
 * @class AutocompleteSearchFormCtrl
 */
class AutocompleteSearchFormCtrl implements IComponentController {
  private selectedItem: {
    value: string
    count: number
  }
  // フォームタイプ: 例: hashtag, account, postTag, accountTag
  private snsType: string
  private type: string
  private label: string
  private selectedValue: string
  private searchStrings: string
  private querySearch: Function
  private onChange: Function

  constructor($element) {
    setTimeout(() => {
      const mdAutocompleteCtrl = $element.find('md-autocomplete-wrap').scope()

      if (mdAutocompleteCtrl !== undefined) {
        const inputAccount = $element.find('input')

        // blurイベントを指定
        inputAccount[0].onblur = () => {
          setTimeout(() => {
            // アカウントが選択されていない場合、入力したアカウントをリセット
            if (!this.selectedItem) {
              mdAutocompleteCtrl.$mdAutocompleteCtrl.scope.searchText = ''
              this.searchStrings = ''
            }
          }, 500)
        }
      }
    }, 500)
  }

  /**
   * 初期化イベント
   */
  public $onInit() {
    switch (this.type) {
      case 'hashtag':
        this.label = 'ハッシュタグ'
        break
      case 'postTag':
        this.label = '投稿タグ'
        break
      case 'accountTag':
        this.label = 'アカウントタグ'
        break
      case 'account':
        this.label = 'アカウント'
        break
      default:
        this.label = 'ハッシュタグ'
    }
    // Youtubeの場合は、ラベルをセット
    if (this.snsType === 'youtube' && this.label === 'ハッシュタグ') {
      this.label = '動画タグ'
    }
    if (this.selectedValue) {
      this.selectedItem = {
        value: this.selectedValue,
        count: 0,
      }
    }
  }

  /**
   * 更新イベント
   * @param changeObj 対象更新
   */
  public $onChanges(changeObj: IOnChangesObject) {
    if (changeObj.selectedValue && changeObj.selectedValue.currentValue) {
      this.selectedItem = {
        value: changeObj.selectedValue.currentValue,
        count: 0,
      }
      this.changeSearchValue()
    }
  }

  /**
   * オートコンプリート検索の変更
   */
  public changeSearchValue() {
    let searchStrings = null
    if (this.selectedItem && this.selectedItem.value) {
      searchStrings = this.selectedItem.value
    }
    if (typeof this.onChange === 'function') {
      this.onChange({ searchStrings: searchStrings })
    }
  }

  public resetSearchValue() {
    this.selectedItem = null
    this.searchStrings = null
  }
}

/**
 * オートコンプリート検索フォーム
 * attr: {string} selectedValue 選択しているバリュー
 * attr: {string} type タイプ
 * attr: {function} onChange オートコンプリート検索の変更イベント
 */
app.component('autocompleteSearchForm', {
  bindings: {
    selectedValue: '<',
    snsType: '<',
    type: '@',
    querySearch: '&',
    onChange: '&',
  },
  template: require('./autocomplete-search-form.pug')(),
  controller: AutocompleteSearchFormCtrl,
})
